module.exports = __webpack_public_path__ + "date-filter.png";